module.exports = "\n<div id=\"{{name}}\" > \n</div>\n\n"